import { useState } from "react";
import { CreditCard, Landmark, ChevronLeft } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { residentApi, errMsg } from "../../lib/api";
import { money } from "../../lib/format";
import { BankTransfer } from "./BankTransfer";

const Option = ({ icon: Icon, title, text, onClick, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className="w-full flex items-center gap-4 p-5 rounded-2xl border border-black/10 hover:border-[#1B4332] hover:bg-[#D8F3DC]/40 text-left transition-colors">
    <span className="w-12 h-12 rounded-2xl bg-[#1B4332] text-white flex items-center justify-center shrink-0"><Icon size={22} /></span>
    <span><span className="block font-bold text-slate-800">{title}</span><span className="text-sm text-slate-500">{text}</span></span>
  </button>
);

export const PayDialog = ({ open, onOpenChange, balance, bank, resident }) => {
  const [method, setMethod] = useState(null);
  const [token, setToken] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const total = balance * (1 + bank.commission);

  const close = (v) => {
    onOpenChange(v);
    if (!v) { setMethod(null); setToken(null); setErr(""); }
  };

  const startCard = async () => {
    setMethod("kart");
    setErr("");
    setBusy(true);
    try {
      const r = await residentApi.post("/resident/payment/init");
      setToken(r.data.token);
    } catch (e) {
      setErr(errMsg(e, "Ödeme başlatılamadı"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className={`rounded-3xl ${token ? "max-w-3xl" : "max-w-lg"} max-h-[92vh] overflow-y-auto`} data-testid="pay-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Borç Ödeme</DialogTitle>
          <DialogDescription>Ödenecek borç: <strong className="text-[#1B4332]" data-testid="pay-dialog-amount">{money(balance)}</strong></DialogDescription>
        </DialogHeader>
        {method && (
          <button onClick={() => { setMethod(null); setToken(null); setErr(""); }} className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500" data-testid="pay-back-btn">
            <ChevronLeft size={16} /> Ödeme yöntemleri
          </button>
        )}
        {!method && (
          <div className="space-y-3">
            {bank.card_enabled && (
              <Option icon={CreditCard} title="Kredi / Banka Kartı ile Öde" testid="pay-method-card" onClick={startCard}
                text={`%${Math.round(bank.commission * 100)} banka komisyonu dahil ${money(total)}`} />
            )}
            <Option icon={Landmark} title="Havale / EFT" text="IBAN bilgilerini kopyalayın, bankanızdan gönderin" testid="pay-method-transfer" onClick={() => setMethod("havale")} />
            {!bank.card_enabled && <p className="text-xs text-slate-400" data-testid="card-disabled-note">Kartla ödeme yakında aktif olacaktır.</p>}
          </div>
        )}
        {method === "kart" && (
          <div data-testid="card-payment-area">
            {busy && <p className="text-slate-500 py-8 text-center">Güvenli ödeme sayfası hazırlanıyor...</p>}
            {err && <p className="text-red-600 py-4" data-testid="card-payment-error">{err}</p>}
            {token && (
              <iframe title="PayTR güvenli ödeme" src={`https://www.paytr.com/odeme/guvenli/iframe_${token}`} className="w-full min-h-[620px] border-0 rounded-xl" data-testid="paytr-iframe" />
            )}
          </div>
        )}
        {method === "havale" && <BankTransfer banks={bank.banks} balance={balance} resident={resident} />}
      </DialogContent>
    </Dialog>
  );
};
